var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.33398 1L12.0007 11.6667L22.6673 1","stroke":"#EEEEEE","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

DownArrow.defaultProps = {"width":"24","height":"13","viewBox":"0 0 24 13","fill":"none"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
